import React, { useState } from 'react';
import CampaignLogo from '../../CampaignLogo/CampaignLogo';
import NavigationItem from '../NavigationItem/NavigationItem';
import CompetitionLogoImage from '../../../assets/images/logo-brand-competition.svg';
import MenuItemPlaceholder from '../../UI/Placeholder/MenuItemPlaceholder/MenuItemPlaceholder';
import classes from './MainMenu.module.scss';
import { IconExternalLink } from '@tabler/icons-react';

import { Button, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';

const MainMenu = ({ primaryNavigation, primaryNavigationCTA }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    let primaryNavContent = (
        <React.Fragment>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
            <li style={{ width: '140px', padding: '8px' }}>
                <MenuItemPlaceholder />
            </li>
        </React.Fragment>
    );
    let primaryNavCTAContent = '';

    if (primaryNavigation) {
        primaryNavContent = primaryNavigation.map((menuItem, index) => {
            return (
                <NavigationItem key={index} type="header">
                    {/https?:\/\/.*/.test(menuItem.linkTarget) ? (
                        <a
                            className={classes.NavLink + ` anl_main-menu--lnk-${index + 1} nav-link`}
                            href={menuItem.linkTarget}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {menuItem.text} <IconExternalLink size={20} className="ms-1" />
                        </a>
                    ) : (
                        <NavLink
                            className={classes.NavLink + ` anl_main-menu--lnk-${index + 1}`}
                            to={menuItem.linkTarget === '/' ? '/' : menuItem.linkTarget + '/'}
                            tag={RRNavLink}
                            exact
                        >
                            {menuItem.text}
                        </NavLink>
                    )}
                </NavigationItem>
            );
        });

        primaryNavCTAContent = primaryNavigationCTA.map((menuItem, index) => {
            return /https?:\/\/.*/.test(menuItem.linkTarget) ? (
                <a href={menuItem.linkTarget} key={index} target="_blank" rel="noopener noreferrer">
                    <Button color="secondary" className={`anl_main-menu--btn-${index + 1}`}>
                        {menuItem.text}&nbsp;
                        <IconExternalLink size={20} className="ms-1" />
                    </Button>
                </a>
            ) : (
                <Button
                    key={index}
                    color="secondary"
                    to={menuItem.linkTarget}
                    tag={RRNavLink}
                    className={`anl_main-menu--btn-${index + 1}`}
                >
                    {menuItem.text}
                </Button>
            );
        });
    }

    return (
        <Navbar className={classes.Navbar} light expand="lg">
            <NavbarBrand
                className={`${classes.NavbarBrand} anl_logo--contest`}
                tag={RRNavLink}
                to="/"
                exact
                title="Startseite"
            >
                <CampaignLogo src={CompetitionLogoImage} />
            </NavbarBrand>

            <NavbarToggler className="anl_mobile--menu" onClick={toggle} onBlur={toggle} />

            <Collapse className="justify-content-end" isOpen={isOpen} navbar>
                <Nav className="ms-auto" navbar>
                    {primaryNavContent}
                </Nav>
                {primaryNavCTAContent}
            </Collapse>
        </Navbar>
    );
};

export default MainMenu;
